import React, { FC } from "react";

import SecurityTopic from "@/pages/SecurityAwareness/components/SecurityTopic";
import { ITopic, SecurityTopicEnum } from "@/pages/SecurityAwareness/types";
import {
  mobileThreatsQuiz,
  mobileThreatsSlides,
} from "@/constants/mobileThreats";

const MobileThreats: FC<ITopic> = ({
  handleNextTopic,
  isPassed,
  setTestResults,
}) => {
  return (
    <SecurityTopic
      slides={mobileThreatsSlides}
      quizName={SecurityTopicEnum.MobileThreats}
      quizList={mobileThreatsQuiz}
      handleNextTopic={handleNextTopic}
      isPassed={isPassed}
      setTestResults={setTestResults}
    />
  );
};

export default MobileThreats;
